import type { DepartmentObservation } from 'types/insights'
import { formatCompactCurrency, stringToTitleCase } from '../utils'
import type { WhereRow } from './types'

export const formatCompPercent = (compPct: number): string =>
    `${compPct.toFixed(1)}%`

export const buildWhereRows = (
    observations: DepartmentObservation[] | undefined,
    statusStrongLabel: string,
    statusWeakLabel: string,
): WhereRow[] => {
    if (!observations?.length) return []
    return observations.map((obs) => {
        const compDistrictPct = obs.district_sales_comp_gap_percent ?? 0
        const isStrong = compDistrictPct >= 0
        const compDistrictText = `${formatCompPercent(compDistrictPct)}`
        const statusText = isStrong ? statusStrongLabel : statusWeakLabel
        return {
            area: stringToTitleCase(obs.department) ?? '-',
            value:
                obs.dollar_value !== undefined
                    ? formatCompactCurrency(obs.dollar_value)
                    : '-',
            comp_store: `${formatCompPercent(obs.sales_comp_percent ?? 0)}`,
            comp_district: {
                cellValue: compDistrictText,
                cellDisplay: (
                    <strong className={!isStrong ? 'hc8-clr-error' : undefined}>
                        {compDistrictText}
                    </strong>
                ),
            },
            status: {
                cellValue: statusText,
                cellDisplay: (
                    <strong
                        className={
                            isStrong ? 'hc8-clr-success' : 'hc8-clr-error'
                        }
                    >
                        {statusText}
                    </strong>
                ),
            },
        }
    })
}
